export default __webpack_public_path__ + "static/media/donations.1b76b906.jpg";